import * as React from "react";
import {FormBodyProps} from "../../../common/props/FormBodyProps";
import JobTypeForm from "./JobTypeForm";
import SectionView from "../../../layout/section/SectionView";
import InputFormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import CheckboxFormGroup from "../../../ui/form/CheckboxFormGroup";
import ActivityTemplateFormGroup from "./activity/ActivityTemplateFormGroup";
import RangeNumberInputFormGroup from "../../../ui/form/RangeNumberInputFormGroup";

type Props = FormBodyProps<JobTypeForm>

export default class JobTypeFormBody extends React.PureComponent<Props, {}> {
	render() {
		return (
			<SectionView>
				<div className={"c-edit-lead-status"}>
					<InputFormGroup label="Label"
									placeholder="Enter job type label"
									field={this.props.form.label}
									disabled={true}
									onChange={this.props.onFieldChange}
									focus={this.props.form.hasFocus(this.props.form.label)}/>
					<ActivityTemplateFormGroup label="Activity template"
											   field={this.props.form.activityTemplateId}
											   disabled={true}
											   onChange={this.props.onFieldChange}/>
					<RangeNumberInputFormGroup field={this.props.form.fee}
											   minValue={0}
											   maxValue={100}
											   placeholder={"Enter fee"}
											   onChange={this.props.onFieldChange}
											   label={"Fee"}
											   focus={this.props.form.hasFocus(this.props.form.fee)}
											   maxDecimalPlaces={2}/>
					<CheckboxFormGroup field={this.props.form.repairWithParts}
									   disabled={true}
									   onChange={this.props.onFieldChange}
									   label={"Repairs with parts"}/>
					<CheckboxFormGroup field={this.props.form.labourOnly}
									   onChange={this.props.onFieldChange}
									   label={"Labour only"}/>
					<CheckboxFormGroup field={this.props.form.active}
									   onChange={this.props.onFieldChange}
									   label={"Active"}/>
				</div>
			</SectionView>
		);
	}
}
